var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"794px","height":"1123px","border":"1px solid #000000"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }